import { toast } from 'sonner';

import { enhancedFirmApi } from '@/services/api/firmsService';

export const useUpdateFirmHipaaAttorneyRelationshipForm = ({
  firmId,
}: {
  firmId: string | undefined;
}) => {
  const [setHipaaAttorneyRelationshipForm] =
    enhancedFirmApi.useSetHipaaAttorneyRelationshipFormMutation();

  const handleUpdate = (file: File | null) => {
    if (!firmId) {
      toast.error('Firm not found');
      return;
    }

    setHipaaAttorneyRelationshipForm({
      id: firmId,
      setHipaaAttorneyRelationshipFormSchema: {
        hipaa_attorney_relationship_form: file,
      },
    })
      .then(() => {
        toast.success('HIPAA attorney relationship form updated');
      })
      .catch(() => {
        toast.error('Failed to update HIPAA attorney relationship form');
      });
  };

  return { handleUpdate };
};

export const useUpdateFirmHipaaReproductiveRightsAttestation = ({
  firmId,
}: {
  firmId: string | undefined;
}) => {
  const [setHipaaReproductiveRightsAttestation] =
    enhancedFirmApi.useSetHipaaReproductiveRightsAttestationMutation();

  const handleUpdate = (file: File | null) => {
    if (!firmId) {
      toast.error('Firm not found');
      return;
    }

    setHipaaReproductiveRightsAttestation({
      id: firmId,
      setHipaaReproductiveRightsAttestationSchema: {
        hipaa_reproductive_rights_attestation: file,
      },
    })
      .then(() => {
        toast.success('HIPAA reproductive rights attestation updated');
      })
      .catch(() => {
        toast.error('Failed to update HIPAA reproductive rights attestation');
      });
  };

  return { handleUpdate };
};
